<template>
  <div class="text-white p-5 font-size-30">
    <div class="font-weight-bold mb-3">
      {{ $t("error404.pageInaccessible") }}
    </div>
    <div>
      {{ $t("error404.subscriptionMessage") }}
      {{ $t("error404.upgradeMessage") }}
    </div>
    <div class="font-weight-bold font-size-70 mb-1">404 —</div>
    <router-link to="/profile" class="btn btn-outline-primary width-100">{{
      $t("error404.returnButton")
    }}</router-link>
  </div>
</template>
<script>
export default {
  name: "CuiError404",
};
</script>
